import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import 'fabric';
declare const fabric: any;
declare var $: any;
import { NgxImageCompressService } from 'ngx-image-compress';
@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss']
})
export class CanvasComponent implements OnInit {
  showColorList = false;
  @Input() backGroundImagePath: string;
  @Input() basedOnEditability: string;
  @Input() svgPreviewPath: any;
  @Input() fieldId: any;
  @Output() svgPath = new EventEmitter < any > ();
  @Output() clear = new EventEmitter < any > ();
  canvas;
  thumbnailCanvas;
  gettingValueforEraserAndPen = 'pen';
  showWidthThickness = 6;
  showColorValue = [
    '#1A1A1A',
    '#800000',
    '#0F4D24',
    '#13134D',
    '#4D0033',
    '#00334D',
    '#808080',
    '#F27979',
    '#47B36B',
    '#5959B3',
    '#1A1A1A',
    '#800000',
    '#0F4D24',
    '#fff',
    '#4D0033',
    '#00334D',
    '#808080',
    '#F27979',
    '#47B36B',
    '#5959B3',
    '#FFA500'
  ];
  currentColor = '#000';
  constructor(private imageCompress: NgxImageCompressService) {}
  ngOnInit() {}
  ngAfterViewInit() {
    this.InitThis();
    this.svgImage();
    if (this.backGroundImagePath) {
      this.generateSvgCanvas();
    }
  }
  InitThis() {
    this.canvas = new fabric.Canvas(this.fieldId, { isDrawingMode: true });
    this.canvas.freeDrawingBrush.width = 6;
    if (this.backGroundImagePath) {
      document.getElementById(this.fieldId).style.background = 'url(' + this.getBase64String(this.backGroundImagePath) + ')no-repeat 0 0/ 100% 100%';
    }
    this.thumbnailCanvas = new fabric.Canvas('thumbnailCanvas', { isDrawingMode: true });
    this.canvas.on('mouse:move', () => {
      const svgImage = this.canvas.toSVG();
      fabric.loadSVGFromString(svgImage, (objects, options) => {
        var obj = fabric.util.groupSVGElements(objects, options);
        if (obj.height > 0) {
          this.thumbnailCanvas.add(obj).renderAll();
          this.imageCompress.compressFile(this.thumbnailCanvas.toDataURL('image/jpg'), 50, 50).then(
            (result) => {
              this.svgPath.emit({ image: svgImage, thumbnail: this.removeBaseString(result) });
            })
        }
      })
    })
  }
  generateSvgCanvas() {
    let self = this,
      canvasWidth = 457,
      canvasHeight = 354,
      bgImage,
      photoUrlPortrait = this.getBase64String(this.backGroundImagePath);

    $(document).ready(() => {
      self.thumbnailCanvas = new fabric.Canvas('thumbnailCanvas');
      setCanvasSize({ height: canvasHeight, width: canvasWidth });
      setCanvasBackgroundImageUrl(photoUrlPortrait)
    });

    function setCanvasSize(canvasSizeObject) {
      self.thumbnailCanvas.setWidth(canvasSizeObject.width);
      self.thumbnailCanvas.setHeight(canvasSizeObject.height);
    }

    function setCanvasBackgroundImageUrl(url) {
      if (url && url.length > 0) {
        fabric.Image.fromURL(url, function(img) {
          bgImage = img;
          scaleAndPositionImage();
        });
      } else {
        self.thumbnailCanvas.backgroundImage = 0;
        self.thumbnailCanvas.setBackgroundImage('', self.thumbnailCanvas.renderAll.bind(self.thumbnailCanvas));

        self.thumbnailCanvas.renderAll();
      }
    }

    function scaleAndPositionImage() {
      var canvasAspect = canvasWidth / canvasHeight;
      var imgAspect = bgImage.width / bgImage.height;
      var left, top, scaleFactor;

      if (canvasAspect >= imgAspect) {
        scaleFactor = canvasWidth / bgImage.width;
        left = 0;
        top = -((bgImage.height * scaleFactor) - canvasHeight) / 2;
      } else {
        scaleFactor = canvasHeight / bgImage.height;
        top = 0;
        left = -((bgImage.width * scaleFactor) - canvasWidth) / 2;

      }

      self.thumbnailCanvas.setBackgroundImage(bgImage, self.thumbnailCanvas.renderAll.bind(self.thumbnailCanvas), {
        top: top,
        left: left,
        originX: 'left',
        originY: 'top',
        scaleX: scaleFactor,
        scaleY: scaleFactor
      });
      self.thumbnailCanvas.renderAll();

    }
  }
  svgImage() {
    if (this.svgPreviewPath) {
      fabric.loadSVGFromString(this.svgPreviewPath.image, (objects, options) => {
        var obj = fabric.util.groupSVGElements(objects, options);
        this.canvas.add(obj).renderAll();
      })
    }
  }
  onThickNessChange(value) {
    this.canvas.freeDrawingBrush.width = value;
  }

  pen() {
    this.gettingValueforEraserAndPen = 'pen';
    return this.gettingValueforEraserAndPen;
  }

  clearArea() {
    this.canvas.clear();
    this.thumbnailCanvas.clear();
    if (this.backGroundImagePath) {
      this.thumbnailCanvas.setBackgroundImage(this.getBase64String(this.backGroundImagePath));
    }
    this.clear.emit();
  }
  showList() {
    this.showColorList = !this.showColorList;
  }
  updateColor(colors) {
    this.canvas.freeDrawingBrush.color = colors;
    this.currentColor = colors;
    this.showColorList = !this.showColorList;
  }
  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
  removeBaseString(base64String) {
    let thumbImageUrl = base64String.replace('data:image/png;base64,', '');
    thumbImageUrl = thumbImageUrl.replace('data:image/jpeg;base64,', '');
    return thumbImageUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/canvas/canvas.component.ts